
<template>
	<div id="appbox">
		<div class="top_heard">
			<div class="top_box">
				<div class="logo_box"  @click="gohome()">
					<img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;"  height="" srcset="">
				</div>
				<div class="top_gatebox">
					<div class="manage_switch" v-if="screenWidth>785">
						<el-select v-model="manage_url" @change="manageurl"  size="small" class="Site_switch_type" placeholder="选择入口">
						  <el-option
						    v-for="item in manageoptions"
						    :key="item.value"
						    :label="item.label"
						    :value="item.value"
							>
						  </el-option>
						</el-select>
					</div>
					
				</div>
				<div class="top_search_box">
				<!-- 	<div class="top_search">
						<el-select v-model="top_search_url" size="small" class="top_search_type" placeholder="搜索类型">
						  <el-option
						    v-for="item in options"
						    :key="item.value"
						    :label="item.label"
						    :value="item.value">
						  </el-option>
						</el-select>
						<input type="text" autocomplete="off" placeholder="搜索关键词……" class="el-input__inner"  style="border: 0px;width: 200px;height: 30px;">
						<img class="top_search_icon" src="../../../static/img/顶部搜素图标.png" alt="" srcset="">
					</div>
					  -->
				</div>
				<div class="top_right">
					<!-- <div class="top_Mobiletype" @click="goregister()">
						账号注册/绑定
					</div> -->
				<!-- 	<div class=""  @click="goregister()">
						注册
					</div> -->
				</div>
			</div>
			<div class="top_tab_box">
				<div class="toptabnav">
						<el-menu
						  :default-active="activeIndex2"
						  class="el-menu-demo"
						  mode="horizontal"
						  @select="handleSelect"
						  router
						  background-color="#1b9d57"
						  text-color="#FFFFFF"
						  active-text-color="#FFFFFF">
							<el-menu-item index="/Home"  >首页</el-menu-item>
						<el-menu-item index="/Newslist" >研学资讯</el-menu-item>
						<el-menu-item index="/Campmap" >研学地图</el-menu-item>
						
						<el-submenu index="/institution">
						    <template slot="title">研学单位</template>
						    <el-menu-item index="/Camplist" >研学营地</el-menu-item>
						    <el-menu-item index="/Baselist" >研学基地</el-menu-item>
						    <el-menu-item index="/traveler" >研学机构</el-menu-item>
						  </el-submenu>
						
							<el-submenu index="/Courselist">
						    <template slot="title">研学产品</template>
						    <el-menu-item index="/Courselist" >研学课程</el-menu-item>
						<el-menu-item index="/Linelist" >研学线路</el-menu-item>
						  </el-submenu>
						  	<el-submenu index="/authLesson">
						    <template slot="title">认证申请</template>
						    <!-- <el-menu-item><a href="https://admin.henanyanxue.com/_uc/index" target="_blank" style="color: #ffffff;">学生证书申请</a></el-menu-item> -->
						    <el-menu-item index="/authLesson" >课程认证申请</el-menu-item>
						    <el-menu-item index="/authLesson" >基地认证申请</el-menu-item>
						    <el-menu-item index="/authLesson" >机构认证申请</el-menu-item>
						   
						  </el-submenu>
<!--						<el-menu-item index="/Activitylist">活动中心</el-menu-item>-->
						<el-submenu index="/Mentorlist">
						    <template slot="title">证书管理</template>
						    <!-- <el-menu-item><a href="https://admin.henanyanxue.com/_uc/index" target="_blank" style="color: #ffffff;">学生证书申请</a></el-menu-item> -->
						    <el-menu-item index="/Mentorlist" >导师证书查询</el-menu-item>
						   
						  </el-submenu>
						  
              			
						<el-menu-item index="/expertlist" >智库专家</el-menu-item>
             			<el-menu-item index="/OrgRegister" >入驻平台</el-menu-item>
						<!-- <el-menu-item index="/" >研学政策</el-menu-item> -->
					</el-menu>
				</div>
			</div>
		</div>
		<div class="register_box">
			<div class="register_main">
				<div class="register_step">
					<el-steps :active="stepid" :space="250" direction="horizontal" :align-center="true" finish-status="success">
					  <el-step title="第一步选择类型"></el-step>
					  <el-step title="第二步完善信息"></el-step>
					  <el-step title="第三部注册成功"></el-step>
					</el-steps>
				</div>
				<div class="register_main1" v-if="stepid==0">
					
					<div class="register_type slsicon" @click="register_typechange(6)" >
						<i class="el-icon-s-grid" style="font-size: 45px;"></i>
						<div class="type_title">
							百线百课注册
						</div>
						<div class="checkiconbox" >
							<i class="el-icon-check"></i>
						</div>
					</div>
					<div class="register_type" @click="gologin()" >
						<i class="el-icon-monitor" style="font-size: 45px;"></i>
						<div class="type_title">
							百线百课登陆
						</div>
					
					</div> 
				</div>
				<div class="register_frombox" v-if="stepid==1">
					<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" size class="demo-ruleForm">
					  <el-form-item label="手机号码" prop="mobile" v-if="register_type == 1||register_type == 2">
					    <el-input  v-model="ruleForm.mobile" ></el-input>
						<div class="form_tips">
							手机号码将作为账户登录
						</div>
					  </el-form-item>
					  <el-form-item label="姓名" prop="uname" v-if="register_type == 6">
					    <el-input  v-model="OAForm.uname" ></el-input>
						<div class="form_tips">
							请输入您的姓名(如果是企业请输入企业名称)
						</div>
					  </el-form-item>
					
					  <el-form-item label="手机号码" prop="telNumber" v-if="register_type == 6">
					    <el-input  v-model="OAForm.telNumber" ></el-input>
						<div class="form_tips">
							请填写手机号码
						</div>
					  </el-form-item>
					  <el-form-item label="性别" v-if="register_type == 6">
					    <el-select v-model="OAForm.gender"  value-key="title" placeholder="请选择性别" >
					      <el-option
							v-for="(item,index) in genderlist"
							:key="item.id"
							:label="item.title" 
							:value="item">
						   </el-option>
					    </el-select>
					  </el-form-item>
                      <el-form-item label="登录名" prop="loginName" v-if="register_type == 6">
					    <el-input  v-model="OAForm.loginName" ></el-input>
							<div class="form_tips">
								申报系统的登录名
							</div>
					  </el-form-item>
					  <el-form-item label="登录密码" prop="pass" v-if="register_type == 6">
					    <el-input  v-model="OAForm.pass" ></el-input>
						<div class="form_tips">
							请设置登录密码
						</div>
					  </el-form-item>
					  <el-form-item label="确认密码" prop="repass"  v-if="register_type == 6">
					    <el-input  v-model="OAForm.repass" ></el-input>
						<div class="form_tips">
							登录密码和确认密码需一致
						</div>
					  </el-form-item>
					
					  <el-form-item label="所属部门地区" >
						  <div class="department_select">
						  	<el-select v-model="department" style="margin-right: 10px;" value-key="title" @change="getodc(0)" placeholder="" >
						  	 <el-option
						  		v-for="(item,index) in departmentoptions"
						  		:key="item.id"
						  		:label="item.title" 
						  		:value="item">
						  	   </el-option>
						  	</el-select>
						  	<el-select v-model="OAForm.City" style="margin-right: 10px;" v-if="departmentrank.id!=0&&Cityopiton.length"  value-key="name" @change="getodc(1)" placeholder="请选择市级" >
						  	  <el-option
						  		v-for="(item,index) in Cityopiton"
						  		:key="item.id"
						  		:label="item.name" 
						  		:value="item">
						  		   
						  	   </el-option>
						  	</el-select>
						  	<el-select v-model="OAForm.District"  v-if="departmentrank.id==2&&Districtopiton.length"   value-key="name" @change="getodc(2)" placeholder="请选择区级" >
						  	  <el-option
						  		v-for="(item,index) in Districtopiton"
						  		:key="item.id"
						  		:label="item.name" 
						  		:value="item">
						  	   </el-option>
						  	</el-select>
						  </div>
					  </el-form-item>
                      <!-- <el-form-item label="部门级别" v-if="register_type == 6">
					    <el-select v-model="departmentrank"  value-key="title" placeholder="请选择所属部门级别" disabled >
					      <el-option
							v-for="(item,index) in departmentranks"
							:key="item.id"
							:label="item.title" 
							:value="item">
						   </el-option>
					    </el-select>
					  </el-form-item>
					  <el-form-item label="申报类型" >
					    <el-select v-model="OAForm.orgPostId"  value-key="name" placeholder="请选择主岗"  disabled  >
					      <el-option
							v-for="(item,index) in orgPostIdlist"
							:key="item.id"
							:label="item.name" 
							:value="item">
						   </el-option>
					    </el-select>
					  </el-form-item>
					  <el-form-item label="其他类型"  >
					    <el-select v-model="OAForm.orgLevelId"  value-key="name" placeholder="请选择职务级别"disabled >
					      <el-option
							v-for="(item,index) in orgLevelIdlist"
							:key="item.id"
							:label="item.name" 
							:value="item">
						   </el-option>
					    </el-select>
					  </el-form-item> -->
					  <el-form-item label="验证码" prop="captcha"  v-if="register_type == 1||register_type == 2">
					    <el-input  v-model="ruleForm.captcha" ></el-input>
						<el-button type="primary" color="#67C23A" style="margin-left: 10px;" v-if="CD" @click="putyzm()" >获取验证码</el-button>
						<el-button type="primary" color="#C0C4CC" style="margin-left: 10px;" v-else>重新发送{{second}}</el-button>
						<div class="form_tips">
						</div>
					  </el-form-item>
					  <el-form-item label="手机号(法人)" prop="mobile" v-if="register_type == 3||register_type == 4">
					    <el-input  v-model="ruleForm.mobile" :readonly="register_searchtype" ></el-input>
							<div class="form_tips">
								用于搜索和验证您的机构
							</div>
					  </el-form-item>
					  <el-form-item label="验证码" prop="captcha"  v-if="(register_type == 3||register_type == 4)&&register_searchtype==false">
					    <el-input  v-model="ruleForm.captcha" ></el-input>
							<el-button type="primary" color="#67C23A" style="margin-left: 10px;" v-if="CD" @click="putyzm()" >获取验证码</el-button>
							<el-button type="primary" color="#C0C4CC" style="margin-left: 10px;" v-else>重新发送{{second}}</el-button>
							<div class="form_tips">
								验证法人手机号
							</div>
					  </el-form-item>
					  <el-form-item label="登录密码" prop="password" v-if="register_type == 1">
					    <el-input  v-model="ruleForm.password" ></el-input>
						<div class="form_tips">
							请设置登录密码
						</div>
					  </el-form-item>
					  <el-form-item label="确认密码" prop="repassword"  v-if="register_type == 1">
					    <el-input  v-model="ruleForm.repassword" ></el-input>
						<div class="form_tips">
							登录密码和确认密码需一致
						</div>
					  </el-form-item>
				
					  <el-form-item label="" v-if="register_type == 3&&register_searchtype==false">
					     <el-button @click="searchcamp()">搜索基地/营地</el-button>
						 <el-button @click="resetting()">重新选择</el-button>
					  </el-form-item>
					 <el-form-item label="" v-if="register_type == 4&&register_searchtype==false">
					    <el-button @click="searchtraveler()">搜索服务机构</el-button>
						<el-button @click="resetting()">重新选择</el-button>
					 </el-form-item>
					 <el-form-item label=""  v-if="register_type == 5&&register_searchtype==false">
					    <el-button @click="">搜索学校</el-button>
						<el-button @click="resetting()">重新选择</el-button>
					 </el-form-item>
					   <el-form-item label="选择营基地" v-if="register_type == 3&&register_searchtype==true">
					     <el-select v-model="campmsg"  value-key="title" @change="selectcamp" placeholder="请选择要注册的营基地" >
					       <el-option
							v-for="(item,index) in camplist"
							:key="item.id"
							:label="item.title" 
							:value="item">
							   
						   </el-option>
					     </el-select>
					   </el-form-item>
					 <el-form-item :label="campmsg.type==1?'营地名称':'基地名称'" prop="password" v-if="register_type == 3&&register_searchtype==true&&campshow==true">
							<div class="form_msgbox">
								<div class="msgbox_item">
									<div class="formmsg_title">
										{{campmsg.title}}
									</div>
								</div>
							</div>
							<div class="form_tips">
							</div>
					 </el-form-item>
					 <el-form-item label="法人姓名" prop="password" v-if="register_type == 3&&register_searchtype==true&&campshow==true">
						<div class="form_msgbox">
							<div class="msgbox_item">
								<div class="formmsg_title">
									{{campmsg.legal_title}}
								</div>
							</div>
						</div>
						<div class="form_tips">
						</div>
					 </el-form-item>
					 <el-form-item label="法人单位名称" prop="password" v-if="register_type == 3&&register_searchtype==true&&campshow==true">
							<div class="form_msgbox">
								<div class="msgbox_item">
									<div class="formmsg_title">
										{{campmsg.legal_entity}}
									</div>
								</div>
							</div>
							<div class="form_tips">
							</div>
					 </el-form-item>
					 <el-form-item label="法人姓名" prop="password" v-if="register_type == 4&&register_searchtype==true">
					 							<div class="form_msgbox">
					 								<div class="msgbox_item">
					 									<div class="formmsg_title">
					 										{{travelerdata.legal_title}}
					 									</div>
					 								</div>
					 							</div>
					 							<div class="form_tips">
					 							</div>
					 </el-form-item>
					 <el-form-item label="单位名称" prop="password" v-if="register_type == 4&&register_searchtype==true">
					 							<div class="form_msgbox">
					 								<div class="msgbox_item">
					 									<div class="formmsg_title">
					 										{{travelerdata.title}}
					 									</div>
					 								</div>
					 							</div>
					 							<div class="form_tips">
					 							</div>
					 </el-form-item>
					 <el-form-item label="登录账号" prop="name" v-if="register_type == 3&&register_searchtype==true&&campshow==true">
					   <el-input  v-model="campform.name" ></el-input>
						<div class="form_tips">
							请设置登录用的账号名,账号具有唯一性
						</div>
					 </el-form-item>
					 <el-form-item label="真实姓名" prop="truename" v-if="register_type == 3&&register_searchtype==true&&campshow==true">
					   <el-input  v-model="campform.truename" ></el-input>
						<div class="form_tips">
							请填写管理员的真实姓名
						</div>
					 </el-form-item>
					 <el-form-item label="管理员手机号" prop="phone" v-if="register_type == 3&&register_searchtype==true&&campshow==true">
					   <el-input  v-model="campform.phone" ></el-input>
						<div class="form_tips">
							请设置找回密码时，验证的管理员手机号码
						</div>
					 </el-form-item>
					 <el-form-item label="登录账号" prop="name" v-if="register_type == 4&&register_searchtype==true">
					   <el-input  v-model="campform.name" ></el-input>
					 						<div class="form_tips">
					 							请设置登录用的账号名
					 						</div>
					 </el-form-item>
					 <el-form-item label="真实姓名" prop="truename" v-if="register_type == 4&&register_searchtype==true">
					   <el-input  v-model="campform.truename" ></el-input>
					 						<div class="form_tips">
					 							请填写管理员的真实姓名
					 						</div>
					 </el-form-item>
					 <el-form-item label="管理员手机号" prop="phone" v-if="register_type == 4&&register_searchtype==true">
					   <el-input  v-model="campform.phone" ></el-input>
					 						<div class="form_tips">
					 							请设置找回密码时，验证的管理员手机号码
					 						</div>
					 </el-form-item>
					  <el-form-item label="登录密码" prop="password" v-if="register_type != 1&&register_searchtype==true">
					    <el-input  v-model="ruleForm.password" ></el-input>
					  						<div class="form_tips">
					  							请设置登录密码
					  						</div>
					  </el-form-item>
					  <el-form-item label="确认密码" prop="repassword"  v-if="register_type != 1&&register_searchtype==true">
							<el-input  v-model="ruleForm.repassword" ></el-input>
							<div class="form_tips">
								登录密码和确认密码需一致
							</div>
					  </el-form-item>
					  <el-form-item label="指导师身份证" prop="sfzh"  v-if="register_type == 2">
					    <el-input  v-model="mentor.sfzh" ></el-input>
						<div class="form_tips">
						</div>
					  </el-form-item>
					  <el-form-item label="指导师证书号" prop="zsbh"  v-if="register_type == 2">
					    <el-input  v-model="mentor.zsbh" ></el-input>
						<div class="form_tips">
						</div>
					  </el-form-item>
				<!-- 	  <el-form-item label="指导师信息" prop="phone"  v-if="register_type == 2&&mentor.id">
					    <div class="">
					    	
					    </div>
						<div class="form_tips">
						</div>
					  </el-form-item> -->
					  <el-form-item label="账号昵称" prop="nickName" v-if="register_type == 1">
					    <el-input  v-model="ruleForm.nickName" ></el-input>
						<div class="form_tips">
						</div>
					  </el-form-item>
					  <el-form-item>
					    <el-checkbox v-model="agreementchecked" text-color="#606266"  >查看<span stalled="color:rgb(61, 120, 252);">注册服务协议</span>，请勾选后完成{{register_type==1?'注册':'绑定'}}</el-checkbox>
					  </el-form-item>
					  <el-form-item v-if="register_searchtype||register_type == 1||register_type == 2||register_type == 6" >
					    <el-button type="primary" @click="register('ruleForm')" v-if="register_type==1">确定注册</el-button>
						<el-button type="primary" @click="OAregister()" v-if="register_type==6">确定注册</el-button>
						<el-button type="primary" @click="bindmentor('ruleForm')" v-if="register_type==2">确定绑定</el-button>
						<el-button type="primary" @click="bindcamp('ruleForm')" v-if="register_type==3&&campshow==true">确定绑定</el-button>
						<el-button type="primary" @click="bindtraveler('ruleForm')" v-if="register_type==4">确定绑定</el-button>
					    <el-button @click="resetting()">重新选择</el-button>
					  </el-form-item>
					</el-form>
				</div>
				<div class="register_finality" v-if="stepid==2">
					<div class="register_finality_icon" v-if="register_type!=1&&register_type!=2">
						<img src="../../../static/img/完成.png" alt="" srcset="">
					</div>
					<div class="register_finality_icon" v-if="register_type==1||register_type==2">
						<img src="../../../static/img/suncode.jpg" alt="" srcset="">
					</div>
					<div class="register_finality_title" v-if="register_type==6">
						OA账户注册成功，请在<a href="http://qianjin.wanjiaxiao.cn/" >OA平台使用</a>注册的登录名及密码登录
					</div>
					<div class="register_finality_title" v-if="register_type==2">
						小程序账户指导师绑定成功
					</div>
					<div class="register_finality_title" v-if="register_type==3">
						基地/营地管理账号注册成功！
					</div>
					<div class="register_finality_title" v-if="register_type==4">
						机构机构管理账号注册成功！
					</div>
					<div class="register_finality_subtitle"  v-if="register_type==1||register_type==2">
						请在小程序端使用注册的手机号及密码登录
					</div>
					
					<div class="register_finality_subtitle"  v-if="register_type==3||register_type==4">
						请在<a href="https://admin.henanyanxue.com/" >管理员后台使用</a>注册的账号及密码登录
					</div>
					<div class="register_finality_button">
						<el-button type="success" @click="gologin()">跳转登录页面</el-button>
					</div>
				</div>
				<div class="register_buttonbox1" v-if="stepid==0">
					  <el-button type="primary" @click="next()">确认选择，下一步完善信息</el-button>
				</div>
				<div class="register_tipsbox" v-if="stepid==0">
			<!-- 		<div class="register_tips">
						<div class="register_tips_title">
							普通用户
						</div>
						<div class="register_tips_text">
							如果您是学生、学生家长或其他非研学服务的用户请选择普通用户，普通用户账号可用于登录手机端微信小程序参与研学活动。
						</div>
					</div> -->
					<div class="register_tips">
					<div class="register_tips_text">
							<div>经请示研究决定，“百线百课”报名程序简化，暂时不需要盖章环节，暂时不需要基地营地在用证明。</div>
							<!-- <div>百课百线报名程序简化，暂时不需要基地营地在用证明</div> -->
							<div>注：【附件4】黑龙江省研学精品线路（课程）征集汇总表（地市填报），请单位填完发送至邮箱：yxpt2024@163.com，十个主题，分别填报。上传截止时间参考每个主题的活动方案。</div>
						</div>
					</div>
					<div class="register_tips">
						<!-- <div class="register_tips_title">
							研学指导师
						</div> -->
						<div class="register_tips_text">
							<a href="https://yxwy-1254115215.cos.ap-beijing.myqcloud.com/20240422/9e77b02f110aeb51306d7bfa9eac97a8.pdf" target="_blank">“百线百课”参赛指引说明点击查看pdf</a>
							
						</div>
						
					</div>
					
					<!-- <div class="register_tips">
						<div class="register_tips_title">
							研学基地
						</div>
						<div class="register_tips_text">
							输入手机号并验证后，可以查询是否存在已合作研学基地/营地，如存在则可以注册基地/营地管理账号。
						</div>
					</div>
					<div class="register_tips">
						<div class="register_tips_title">
							服务机构
						</div>
						<div class="register_tips_text">
							输入手机号并验证后，可以查询是否存在已合作研学服务机构/研学机构，如存在则可以绑定服务机构/研学机构。
						</div>
					</div>
					<div class="register_tips">
						<div class="register_tips_title">
							学　　校
						</div>
						<div class="register_tips_text">
							输入手机号并验证后，可以查询是否存在已合作学校，如存在则可以绑定学校。
						</div>
					</div> -->
				</div>
			</div>
		</div>
		<div :class="tops?'navbar':'navbar-top'">
		     <el-tooltip class="item" effect="dark" content="返回首页" placement="left">
		             <a style="display: flex;flex-direction: column;justify-content: center; align-items: center;"  @click="gohome()"><i class="el-icon-s-home"></i>
								<div style="font-size: 14px;">首页</div></a>
		     </el-tooltip>
		     <div  class="qrShow3 right2"   v-if="showofficialQR">
					<img src="../../../static/img/gzhsuncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;" />
				</div>
				<a style="display: flex;flex-direction: column;justify-content: center; align-items: center;" @mouseover="showofficialQRCode" @mouseleave="hideofficialQRCode"><i class="el-icon-s-help"></i>  
							
				    <div style="font-size: 14px;">公众号</div></a>
				<div  class="qrShow2 right2" v-if="showserviceQR">
					<img src="../../../static/img/客服码.png" style="width: 100px; height: 100px;border-radius: 8px;" />
				</div>
				<a style="display: flex;flex-direction: column;justify-content: center; align-items: center;" @mouseover="showserviceQRCode" @mouseleave="hideserviceQRCode"><i class="el-icon-service"></i>  
							
				    <div style="font-size: 14px;">客服</div></a>
		     <div  class="qrShow right" v-if="showQR">
							<img src="../../../static/img/suncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;" />
		     </div>
		       <!-- <a style="display: flex;flex-direction: column;justify-content: center; align-items: center;" @mouseover="showQRCode" @mouseleave="hideQRCode"><i class="el-icon-mobile-phone"></i> 
					
		         <div style="font-size: 14px;">手机端</div></a> -->
		     <el-tooltip class="item" effect="dark" content="返回顶部" placement="left" v-if="tops">
		         <a @click="gotop"><i class="el-icon-caret-top"></i>
		         <br>
		         <span>顶部</span></a>
		     </el-tooltip>
		 </div>
		<div class="pagesbottom_box">
			<div class="subtexts">
				<div v-for="item in bottomnav" :key="item" @click="gobottomnav(item.type,item.linkurl)">{{item.title}}</div>
				<!-- 				<div>商务合作</div>
								<div>招商合作</div>
								<div>广告服务</div>
								<div>线下体验店</div>
								<div>客服中心</div>
								<div>在线留言</div>
								<div>合作伙伴</div>
								<div>联系我们</div>
								<div>人员招聘</div>
								<div>网站地图</div>
								<div>热点关注</div>
								<div>网盟合作</div>
								<div>音乐</div> -->
			</div>
			<div class="row">
				<!-- <div class="copy-left">
					<p><i class="el-icon-phone-outline"></i>{{pcsetdata.phone}}</p>
					<p><i class="el-icon-message"></i>{{pcsetdata.email}}</p>
					<p style="font-size: 13px;">地址信息：{{pcsetdata.address}}</p>
				</div> -->
				
				<div class="copy-left">
					<div class="bottom_logo">
						<img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;"  height="" srcset="">
					</div>
					<!-- <div class="bottom_logo">
						<img src="../../../static/img/logo2.jpg" alt="" style="margin-top: 0px !important;"  height="" srcset="">
					</div> -->
					<!-- <div class="copy-right">
						<img src="../../../static/img/gzhsuncode.jpg" />
					</div>
					<div class="copy-right">
						<img src="../../../static/img/suncode.jpg" />
					</div> -->
				</div>
				<div class="bottom_right">
					<div class="bottom_msg">
						{{pcsetdata.foot}}
					</div>
					<div class="bottom_msg">
						<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">{{' '+pcsetdata.icp}}</a>
					</div>
					<div class="bottom_msg">
						课程适用人群:学生群体
					</div>
				</div>
				
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { getBanner, getWxLogin, getAclist, getNewslist, getCategory, getCamplist, getActivitylist, getPac, getCourselist, getPc, getNt, getTeacher, getAdvbanner, getPlate,getLinelist,yzmsms,register,bindmentor,searchcamp,bindcamp,searchtraveler,bindtraveler,getbottomnav,getodc,getpostlist,getpostlevel,OAregister} from '@/request/api'
import { Loading } from 'element-ui';
// import navTab from '../Navtab/navtab'
	
export default {
  name: "Home",
    // components: {
    //   navTab
    // },
  data(){
	  return {
		  bottomnav:[],
	        // navList: ['标题1', '标题2', '标题3', '标题4'],
	        // navDropList: [{
	        //   title: '菜单1',
	        //   list: ['菜单标题1', '菜单标题2', '菜单标题3']
	        // }, {
	        //   title: '菜单2',
	        //   list: ['菜单标题1', '菜单标题2']
	        // }],
			// activeIndex: '1',
			activeIndex2: '/register',
			top_search_url:'',
			manage_url:'',
			manageoptions:[
				{
				  value: 'http://qianjin.wanjiaxiao.cn/',
				  label: '研学报备'
				}, {
				  value: 'https://admin.henanyanxue.com/',
				  label: '管理入口'
				},
				
			],
			phoneboxshow:false,
			register_searchtype:false,
			stepid:0,
			register_type:6,
			agreementchecked:true,
			platelist:[],
			second: 60,
			CD:true,
			ruleForm: {
			  mobile: '',
			  nickName: '',
			  password: '',
			  repassword: '',
			  unionid:'',
			  openid:'',
			  captcha:'',
			  is_pc:1,
			},
			OAForm: {
				  uname:'',
				  gender:{},
				  telNumber:'',
				  orgDepartmentId:'',
				  orgPostId:{
                    id: "-6161269279165625874",
                    name: "课程线路申报"
                  },
				  orgLevelId:{
                    id: "-3101099424498039708",
                    name: "员工"
                  },
				  loginName: '',
				  pass: '',
				  repass: '',
				  unionid:'',
				  openid:'',
				  captcha:'',
				  District:'',
				  City:'',
				  is_pc:1,
				},
				department:'',
				genderlist:[
					{
						title:'男',
						id:1
					},{
						title:'女',
						id:2
					}
				],
				orgLevelIdlist:[],
				orgPostIdlist:[],
				departmentoptions:[
					{
					  id: '黑龙江',
					  title: '黑龙江'
					},
				],
				Cityopiton:[],
				Districtopiton:[],
			campmsg:{},
			dialogImageUrl: '',
			dialogVisible: false,
			rules: {
				mobile: [
					{ required: true, message: '请输入手机号码', trigger: 'blur' },
					{ min: 11, max: 11, message: '长度在11个数字', trigger: 'blur' }
				],
				nickName: [
					{ required: true, message: '请输入账号昵称', trigger: 'blur' },
				],
				password: [
					{ required: true, message: '请设置登录密码', trigger: 'blur' },
				],
				repassword: [
					{ required: true, message: '请确认登录密码', trigger: 'blur' },
				],
				captcha: [
					{ required: true, message: '请确认验证码', trigger: 'blur' },
					{ min: 6, max: 6, message: '验证码位数错误', trigger: 'blur' }
				],
				
			},
			value:'',
			ranklist:[
				{
				  value: 0,
				  label: '国家级'
				}, {
				  value: 1,
				  label: '省级'
				}, {
				  value: 2,
				  label: '市级'
				}, {
				  value: 3,
				  label: '县级'
				}
			],
			departmentranks:[
				 {
				  id: 2,
				  title: '区级'
				}
			],
			departmentrank: {
				  id: 2,
				  title: '区级'
				},
			newscategory_id:0,
			logintype:true,
			banner:[
			],
			newslist:[],
			aclist:[],
			lessonlist:[],
			categorytypes:[],
			linelist:[],
			lessoncategory_id:0,
			pcsetdata:{},
			ntlist:[],
			mentor:{
				sfzh:'',
				zsbh:'',
			},
			campform:{
				name:'',
				truename:'',
				phone:'',
			},
			travelerdata:{
				
			},
			mentorlist:[],
			camplist:[],
			campshow:false,
			mentor_index:'',
			mentorindex:0,
			mentortotal:0,
			advbanner:[],
			//侧边栏
			 showQR:false,
			 showserviceQR:false,
			  showofficialQR:false,
			tops:false,
			heights:window.innerHeight,
			scrolltop:'',
	      }
  },
  beforeCreate(){
	  //  const loading = this.$loading({
			// lock: true,
			// text: '页面载入……',
			// // spinner: 'el-icon-loading',
			// background: '#ffffff'
		 //  });
  },
  created() {
	  this.getpcset()
  },
  mounted() {
	  this.getpostlist()
	  this.getpostlevel()
	  this.getPlate()
	//   this.getnewstypes()
 //    this._getbanner() 
	// this._getNewslist()
	// this._getCamplist()
	// this._getAclist()
	// this.getlessontypes()
	// this.getlinelist()
	// this.getmentor()
	// this.getNt()
	// this.getAdvbanner()
	 this.getbottomnav()
	 
	// this.getlessonlist()
	window.addEventListener('scroll', this.scrollToTop)
 		
 },
  destroyed () {
	window.removeEventListener('scroll', this.scrollToTop)
   },
  beforeDestroy(){
	
  },
  methods: {
	 manageurl(e){
	 		  console.log('Site',e)
	 		  if(e!='/'){
	 			   window.open(e) 
	 		  }
	 		//this.manage_url='/'
	 		  // window.location.href = e;
	 		  
	 },
	  getpostlevel(){
		var data={
			
		}  
		getpostlevel(data).then(res=>{
			if(res.data.code==200){
				this.orgLevelIdlist=res.data.data
			}
		})
	  },
	  getpostlist(){
		var data={
			
		}  
		getpostlist(data).then(res=>{
			if(res.data.code==200){
				this.orgPostIdlist=res.data.data
			}
		})
	  },
	  getodc(e){
		  
		var data={
			
		}  
		if(e==0){
			// data={
			// 	id:this.OAForm.City.id,
			// }
			this.OAForm.orgDepartmentId=0
		}
		if(e==1){
			data={
				id:this.OAForm.City.id,
			}
			this.OAForm.orgDepartmentId=this.OAForm.City.id
		}
		if(e==2){
			// data={
			// 	id:this.OAForm.District,
			// }
			this.OAForm.orgDepartmentId=this.OAForm.District.id
			return
		}
		getodc(data).then(res=>{
			if(e==0){
				this.Cityopiton=res.data.data
			}
			if(e==1){
				this.Districtopiton=res.data.data
			}
		})
	  },
	  getbottomnav(){
	  		  var data={
	  			  page_index:1,
	  			  page_size:15
	  		  }
	  		getbottomnav(data).then(res=>{
	  			this.bottomnav=res.data.data.list
	  		})  
	  },
	  gobottomnav(type,link){
	  		  if(type==1){
	  			  this.$router.push({
	  			  	path:link
	  			  });
	  		  }else if(type==2){
			  window.location.href = link;
		  }
	  },
	  logout(){
	  			  var that=this
	  			  this.$confirm('是否确认退出登录?', '提示', {
	  			  					confirmButtonText: '确定',
	  			  					cancelButtonText: '取消',
	  			  					type: 'warning'
	  			  }).then(() => {
	  						this.$alert("已退出登录", '', {
	  							confirmButtonText: '确认',
	  							callback: action => {
	  								localStorage.setItem('token', '')
	  								localStorage.setItem('refreshToken', '')
	  								 that.$router.go(0)
	  							}
	  						  });
	  			  }).catch(() => {
	  			  		 
	  			  });
	  },
	  showofficialQRCode(){
		  		 this.showofficialQR=true
		  },
		  hideofficialQRCode(){//隐藏二维码
		      this.showofficialQR = false
		  },
		  showserviceQRCode(){
	  			  this.showserviceQR=true
	  },
	  hideserviceQRCode(){//隐藏二维码
	      this.showserviceQR = false
	  },
	  showQRCode(){//显示二维码
	          this.showQR = true
	      },
	      hideQRCode(){//隐藏二维码
	          this.showQR = false
	      },
	      scrollToTop () {
	          let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
	          this.scrolltop = scrollTop
	          if (parseInt(this.scrolltop) > (parseInt(this.heights) / 3)) {
	              this.tops = true
	          } else {
	              this.tops = false
	          }
	      },
	      gotop () {
	          let timer = setInterval(() => {
	              document.documentElement.scrollTop = document.body.scrollTop = this.scrolltop - 90
	              if (this.scrolltop === 0) {
	                  clearInterval(timer)
	              }
	          }, 15)
	      },
	  bindtraveler(){
		  var that=this;
		  var data={
				legal_mobile:this.ruleForm.mobile,
				captcha:this.ruleForm.captcha,
				name:this.campform.name,
				truename:this.campform.truename,
				mobile:this.campform.phone,
				pass: this.ruleForm.password,
				repass: this.ruleForm.repassword,  
				id:this.travelerdata.id,  
		  }
		  if(this.ruleForm.mobile==''){
		  			this.$alert('请输入手机号，然后发送验证码', '请输入手机号', {
		  				confirmButtonText: '确认',
		  				callback: action => {
		  					
		  				}
		  			});
		    return;
		  }
		  if(this.ruleForm.mobile.length!=11){
		  			this.$alert('手机号长度位数错误', '手机号长度错误', {
		  				confirmButtonText: '确认',
		  				callback: action => {
		  					
		  				}
		  			});
		    return;
		  }
		  if(this.ruleForm.captcha==''){
		  			this.$alert('请填写验证码', '存在未填项', {
		  				confirmButtonText: '确认',
		  				callback: action => {
		  					
		  				}
		  			});
		    return;
		  }
		  if(this.campform.name==''){
		  			this.$alert('请填写登录账号', '存在未填项', {
		  				confirmButtonText: '确认',
		  				callback: action => {
		  					
		  				}
		  			});
		    return;
		  }
		  if(this.campform.truename==''){
		  			this.$alert('请填写真实姓名', '存在未填项', {
		  				confirmButtonText: '确认',
		  				callback: action => {
		  					
		  				}
		  			});
		    return;
		  }
		  if(this.campform.phone==''){
		  			this.$alert('请填写管理员手机号', '存在未填项', {
		  				confirmButtonText: '确认',
		  				callback: action => {
		  					
		  				}
		  			});
		    return;
		  }
		  if( this.ruleForm.password==''){
		  			this.$alert('请设置密码', '存在未填项', {
		  				confirmButtonText: '确认',
		  				callback: action => {
		  					
		  				}
		  			});
		    return;
		  }
		  if( this.ruleForm.repassword==''){
		  			this.$alert('请确认密码', '存在未填项', {
		  				confirmButtonText: '确认',
		  				callback: action => {
		  					
		  				}
		  			});
		    return;
		  }
		  if(this.ruleForm.password!=this.ruleForm.repassword){
		  							this.$alert('登录密码和确认密码不一致', '登录密码和确认密码不一致', {
		  								confirmButtonText: '确认',
		  								callback: action => {
		  									
		  								}
		  							});
		      return
		  }
		  bindtraveler(data).then(res=>{
		  			  that.$alert('机构注册管理账号成功', '注册成功', {
		  			  	confirmButtonText: '确认',
		  			  	callback: action => {
		  			  		that.next()
		  			  	}
		  			  });
		  })
	  },
	  searchtraveler(){
		var that=this
		var data={
			legal_mobile:this.ruleForm.mobile,
			 captcha:this.ruleForm.captcha,
		}  
		if(this.ruleForm.mobile==''){
					this.$alert('请输入手机号，然后发送验证码', '请输入手机号', {
						confirmButtonText: '确认',
						callback: action => {
							
						}
					});
		  return;
		}
		if(this.ruleForm.mobile.length!=11){
					this.$alert('手机号长度位数错误', '手机号长度错误', {
						confirmButtonText: '确认',
						callback: action => {
							
						}
					});
		  return;
		}
		if(this.ruleForm.captcha==''){
					this.$alert('请填写验证码', '存在未填项', {
						confirmButtonText: '确认',
						callback: action => {
							
						}
					});
		  return;
		}
		searchtraveler(data).then(res=>{
			console.log(res.data.data)
			this.travelerdata=res.data.data
			this.register_searchtype=true
		})
		
		
	  }, 
	  searchcamp(){
		var that=this
		var data={
			legal_mobile:this.ruleForm.mobile,
			 captcha:this.ruleForm.captcha,
		}  
		if(this.ruleForm.mobile==''){
					this.$alert('请输入手机号，然后发送验证码', '请输入手机号', {
						confirmButtonText: '确认',
						callback: action => {
							
						}
					});
		  return;
		}
		if(this.ruleForm.mobile.length!=11){
					this.$alert('手机号长度位数错误', '手机号长度错误', {
						confirmButtonText: '确认',
						callback: action => {
							
						}
					});
		  return;
		}
		if(this.ruleForm.captcha==''){
					this.$alert('请填写验证码', '存在未填项', {
						confirmButtonText: '确认',
						callback: action => {
							
						}
					});
		  return;
		}
		searchcamp(data).then(res=>{
			console.log(res.data.data)
			this.camplist=res.data.data
			
			this.register_searchtype=true
		})
	  },
	  selectcamp(e){
			console.log(e)
			this.campmsg=e
			this.campshow=true
	  },
	  bindcamp(formName){
		  var that=this;
		  var data={
			  legal_mobile:this.ruleForm.mobile,
			  captcha:this.ruleForm.captcha,
			  name:this.campform.name,
			  truename:this.campform.truename,
			  mobile:this.campform.phone,
			  pass: this.ruleForm.password,
			  repass: this.ruleForm.repassword,  
			  camp_id:this.campmsg.id,  
		  }
		  if(this.ruleForm.mobile==''){
		  			this.$alert('请输入手机号，然后发送验证码', '请输入手机号', {
		  				confirmButtonText: '确认',
		  				callback: action => {
		  					
		  				}
		  			});
		    return;
		  }
		  if(this.ruleForm.mobile.length!=11){
		  			this.$alert('手机号长度位数错误', '手机号长度错误', {
		  				confirmButtonText: '确认',
		  				callback: action => {
		  					
		  				}
		  			});
		    return;
		  }
		  if(this.ruleForm.captcha==''){
		  			this.$alert('请填写验证码', '存在未填项', {
		  				confirmButtonText: '确认',
		  				callback: action => {
		  					
		  				}
		  			});
		    return;
		  }
		  if(this.campform.name==''){
		  			this.$alert('请填写登录账号', '存在未填项', {
		  				confirmButtonText: '确认',
		  				callback: action => {
		  					
		  				}
		  			});
		    return;
		  }
		  if(this.campform.truename==''){
		  			this.$alert('请填写真实姓名', '存在未填项', {
		  				confirmButtonText: '确认',
		  				callback: action => {
		  					
		  				}
		  			});
		    return;
		  }
		  if(this.campform.phone==''){
		  			this.$alert('请填写管理员手机号', '存在未填项', {
		  				confirmButtonText: '确认',
		  				callback: action => {
		  					
		  				}
		  			});
		    return;
		  }
		  if( this.ruleForm.password==''){
		  			this.$alert('请设置密码', '存在未填项', {
		  				confirmButtonText: '确认',
		  				callback: action => {
		  					
		  				}
		  			});
		    return;
		  }
		  if( this.ruleForm.repassword==''){
		  			this.$alert('请确认密码', '存在未填项', {
		  				confirmButtonText: '确认',
		  				callback: action => {
		  					
		  				}
		  			});
		    return;
		  }
		  if(this.ruleForm.password!=this.ruleForm.repassword){
		  							this.$alert('登录密码和确认密码不一致', '登录密码和确认密码不一致', {
		  								confirmButtonText: '确认',
		  								callback: action => {
		  									
		  								}
		  							});
		      return
		  }
		  bindcamp(data).then(res=>{
			  that.$alert('机构注册管理账号成功', '注册成功', {
			  	confirmButtonText: '确认',
			  	callback: action => {
			  		that.next()
			  	}
			  });
		  })
	  },
	  bindmentor(formName){
		  var that=this;
		  var data={
			mobile:this.ruleForm.mobile,
			sfzh:this.mentor.sfzh,
			zsbh:this.mentor.zsbh,
			captcha:this.ruleForm.captcha,
		  }
		  if(this.ruleForm.mobile==''){
		  			this.$alert('请输入手机号，然后发送验证码', '请输入手机号', {
		  				confirmButtonText: '确认',
		  				callback: action => {
		  					
		  				}
		  			});
		    return;
		  }
		  if(this.ruleForm.mobile.length!=11){
		  			this.$alert('手机号长度位数错误', '手机号长度错误', {
		  				confirmButtonText: '确认',
		  				callback: action => {
		  					
		  				}
		  			});
		    return;
		  }
		  if(this.ruleForm.captcha==''){
		  			this.$alert('请填写验证码', '存在未填项', {
		  				confirmButtonText: '确认',
		  				callback: action => {
		  					
		  				}
		  			});
		    return;
		  }
		  if(this.mentor.sfzh==''){
		  			this.$alert('请填写指导师身份证号码', '存在未填项', {
		  				confirmButtonText: '确认',
		  				callback: action => {
		  					
		  				}
		  			});
		    return;
		  }
		  if(this.mentor.zsbh==''){
		  			this.$alert('请填写指导师证书编号', '存在未填项', {
		  				confirmButtonText: '确认',
		  				callback: action => {
		  					
		  				}
		  			});
		    return;
		  }
		  bindmentor(data).then(res=>{
			  that.$alert('小程序账号绑定指导师成功', '绑定成功', {
			  	confirmButtonText: '确认',
			  	callback: action => {
			  		that.next()
			  	}
			  });
		  })
		  
	  },
	  timer() {
	    let promise = new Promise((resolve, reject) => {
	      let setTimer = setInterval(
	        () => {
	            this.second= this.second - 1;
	          if (this.second <= 0) {
	              this.second= 60;
	              this.send=true
	            resolve(setTimer)
	          }
	        }
	        , 1000)
	    })
		promise.then((setTimer) => {
			this.CD=true;
		    clearInterval(setTimer)
		  })
		},
		putyzm(e){
		  var data={
		    mobile:this.ruleForm.mobile
		  }
		  if(this.ruleForm.mobile==''){
			this.$alert('请输入手机号，然后发动验证码', '请输入手机号', {
				confirmButtonText: '确认',
				callback: action => {
					
				}
			});
		    return;
		  }
		  console.log(this.ruleForm.mobile.length)
		  if(this.ruleForm.mobile.length!=11){
			this.$alert('手机号长度位数错误', '手机号长度错误', {
				confirmButtonText: '确认',
				callback: action => {
					
				}
			});
		    return;
		  }
		  this.CD=false;
		  this.timer();
		  yzmsms(data).then(res=>{
			   console.log(res)
		  })
		},
		OAregister(){
			var that=this;
			const {uname,loginName,gender,telNumber,orgDepartmentId,orgPostId,orgLevelId,pass,repass}=this.OAForm;
			var data={
				uname,
				loginName,
				gender,
				telNumber,
				orgDepartmentId,
				orgPostId,
				orgLevelId,
				pass,
				repass,
			}
			if(data.uname==''){
				this.$alert('请填写姓名', '存在未填项', {
					confirmButtonText: '确认',
					callback: action => {
						
					}
				});
				return
			}
			if(data.loginName==''){
				this.$alert('请填写登录名', '存在未填项', {
					confirmButtonText: '确认',
					callback: action => {
						
					}
				});
				return
			}
			if(data.gender==''){
				this.$alert('请选择性别', '存在未选项', {
					confirmButtonText: '确认',
					callback: action => {
						
					}
				});
				return
			}
			if(data.telNumber==''){
				this.$alert('请填写手机号', '存在未填项', {
					confirmButtonText: '确认',
					callback: action => {
						
					}
				});
				return
			}
			if(data.orgDepartmentId===''){
				this.$alert('请选择部门区域', '存在未选项', {
					confirmButtonText: '确认',
					callback: action => {
						
					}
				});
				return
			}
			if(data.orgPostId==''){
				this.$alert('请选择主岗', '存在未选项', {
					confirmButtonText: '确认',
					callback: action => {
						
					}
				});
				return
			}
			if(data.orgLevelId==''){
				this.$alert('请选择职务级别', '存在未选项', {
					confirmButtonText: '确认',
					callback: action => {
						
					}
				});
				return
			}
			if(data.pass==''){
						this.$alert('请设置密码', '存在未填项', {
							confirmButtonText: '确认',
							callback: action => {
								
							}
						});
			  return;
			}
			if(data.repass==''){
						this.$alert('请确认密码', '存在未填项', {
							confirmButtonText: '确认',
							callback: action => {
								
							}
						});
			  return;
			}
			data.gender=this.OAForm.gender.id
			// data.orgDepartmentId=this.OAForm.orgDepartmentId.id
			data.orgPostId=this.OAForm.orgPostId.id

			data.orgLevelId=this.OAForm.orgLevelId.id
			OAregister(data).then(res=>{
				if(res.data.code==200){
					that.$alert('OA账号注册成功', '注册成功', {
						confirmButtonText: '确认',
						callback: action => {
							that.next()
						}
					});
				}
			})
		},
	   register(formName){
	      var that=this;
		  var data=this.ruleForm;
		  this.$refs[formName].validate((valid) => {
		            if (valid) {
		              // alert('submit!');
					  if(this.ruleForm.password!=this.ruleForm.repassword){
							this.$alert('登录密码和确认密码不一致', '登录密码和确认密码不一致', {
								confirmButtonText: '确认',
								callback: action => {
									
								}
							});
					      return
					  }
					  if(this.agreementchecked==false){
						this.$alert('有未同意的协议，请同意协议后重试', '请同意协议', {
							confirmButtonText: '确认',
							callback: action => {
								
							}
						});
					    return;
					  }
					  register(data).then(res=>{
						  console.log(res)
						  that.$alert('小程序账号注册成功', '注册成功', {
						  	confirmButtonText: '确认',
						  	callback: action => {
						  		that.next()
						  	}
						  });
					  })
		            } else {
		              console.log('error submit!!');
		              return false;
		            }
		          });
	    },
	  showphonebox(){
	  		this.phoneboxshow=true  
	  },
	  closephonebox(){
	  		this.phoneboxshow=false  
	  },
	  gologin(){
		window.open("http://xh.wanjiaxiao.cn/")
	  },
	  gohome(e) {
	    this.$router.push({
	      path: "/Home",
	      name: "/Home",
	  			  query: {
	  			  }
	    });
	  },
	  handleRemove(file, fileList) {
	          console.log(file, fileList);
	        },
	        handlePictureCardPreview(file) {
	          this.dialogImageUrl = file.url;
	          this.dialogVisible = true;
	        },
	  register_typechange(e){
		this.register_type=e  
	  },
	  resetting(){
		this.stepid=0
		this.register_searchtype=false
		this.ruleForm={
			  mobile: '',
			  nickName: '',
			  password: '',
			  repassword: '',
			  unionid:'',
			  openid:'',
			  captcha:'',
			  is_pc:1,
			}
		this.campmsg={}
		this.camplist=[]
			
	  },
		next(){
			// if(this.register_type==6){
			// 	this.$alert('该功能暂未开放', '暂未开放', {
			// 		confirmButtonText: '确认',
			// 		callback: action => {
						
			// 		}
			// 	});
			// 	return
			// }
		  if (this.stepid <3){
			  this.stepid=this.stepid+1
		  }
		},
	   showstep(ind) {
	        this.$refs.carousel.setActiveItem(ind)
	      },
		  goplate(id){
			  
		  },
	  getPlate(){
		var data={
			
		}  
		getPlate(data).then(res=>{
			this.platelist=res.data.data
		})
	  },
	  getlinelist(){
		  var data={
			  page_index: 1,
			  page_size: 4,
		  }
		  getLinelist(data).then(res=>{
		  	console.log(res.data)
		  	this.linelist=res.data.data.list
		  	// this.quicklist=res.data.data.list
		  }).catch(error => {
		  	console.error(error);
		  });
	  },
	  getAdvbanner(){
		var data={
			is_pc:2,
			flag:'A'
		}  
		getAdvbanner(data).then(res=>{
			console.log('getAdvbanner',res)
			this.advbanner=res.data.data
		})
	  },
	  changementor(e){
		console.log('1112',e)  
		this.mentorindex=e+1
		this.getmentor()
	  },
	  mentoropen(index){
		this.mentor_index=index  
	  },
	  relist(data){
		  const list = data.split(',');
		  return list
	  },
	  getmentor(){
		  var data={
			  page_index:1,
			  page_size:3
		  }
		  getTeacher(data).then(res=>{
			  this.mentorlist=res.data.data.list
		  })
	  },
	  getNt(){
		getNt().then(res=>{
			this.ntlist=res.data.data
		})  
	  },
	  getpcset(){
		getPc().then(res=>{
			this.pcsetdata=res.data.data
		})  
	  },
	  golesson(e) {
	    this.$router.push({
	      path: "/CourseDetails",
	      name: "CourseDetails",
	      query: {
	        id: e
	      }
	    });
	  },
	  camptypetab(val){
	  			  // this.lessoncategory_id=val
	  			  this.getlessonlist()
	  },
	  getlessontypes(){
	  			var data={}
	  			getPac(data).then(res=>{
	  				console.log(res.data)
	  				this.categorytypes=res.data.data.cat
	  				// this.periodtypes=res.data.data.res
	  				// this.lessoncategory_id=res.data.data.cat[0].id
	  				this.getlessonlist()
	  			}).catch(error => {
	  			  console.error(error);
	  			});
	  },
	  getlessonlist(){
	  			var data={
	  				// type:this.camptype,
	  				category_id:this.lessoncategory_id,
	  				page_index: 1,
	  				page_size: 4,
	  			}  
	  			getCourselist(data).then(res=>{
	  				console.log(res.data)
	  				this.lessonlist=res.data.data.list
					const loading = this.$loading({
					         lock: true,
					         text: 'Loading',
					         spinner: 'el-icon-loading',
					         background: 'rgba(0, 0, 0, 0.7)'
					       });
					loading.close();
	  				// this.total=res.data.data.total
	  				// this.quicklist=res.data.data.list
	  			}).catch(error => {
	  				console.error(error);
	  			});
	  },
	  newshandleClick(e){
			console.log(e,this.category_id)
			this._getNewslist()
	  },
	  getnewstypes(){
		  var data={}
		  getCategory(data).then(res=>{
				  console.log(res.data)
				  this.newstypes=res.data.data
				  this.newscategory_id=res.data.data[0].id
				  this._getNewslist()
			}).catch(error => {
			  console.error(error);
			});
	  },
	  _getNewslist(){
		  var data={
			page_index:1,
			page_size:7,
			category_id:this.newscategory_id,
		  }
		getNewslist(data).then(res=>{
			console.log(res.data)
			this.newslist=res.data.data.list
		  }).catch(error => {
			  console.error(error);
			});
	  },
	  _getCamplist(){
		  var data={
			  page_index:1,
			  page_size:4
		  }
		  getCamplist(data).then(res=>{
				  console.log(res.data)
				  this.Camplist=res.data.data.list
		  }).catch(error => {
		  				  console.error(error);
		  			});
	  },
	  _getAclist(){
		  var data={
			  page_index:1,
			  page_size:3
		  }
		  getAclist(data).then(res=>{
		  			  console.log(res.data)
					  this.aclist=res.data.data.list
		  			  // this.banner=res.data.data
		  }).catch(error => {
				  console.error(error);
			});
	  },
	  _getColumn(){
		  getColumn().then(res=>{
		  			  console.log(res.data)
		  			  // this.banner=res.data.data
		  }).catch(error => {
		  			  console.error(error);
		  			});
	  },
	  _getbanner(){
		  console.log(22233, getBanner())
			var data={
				is_pc:2
			}
		  getBanner(data).then(res=>{
			  console.log(res.data)
			  this.banner=res.data.data
		  }).catch(error => {
			  console.error(error);
			});
	  },
	handleSelect(key, keyPath) {
		console.log(key, keyPath);
	},
	golist(e){
		this.$router.push({
		  path: "/"+e,
		  name:"/"+e,
			query: {
			}
		});
	},
	gontdetails(e){
		this.$router.push({
		  path: "/Ntdetails",
		  name: "Ntdetails",
		  query: {
		    id: e
		  }
		});
	},
    gonews(e){
		this.$router.push({
		  path: "/NewsDetails",
		  name: "NewsDetails",
		  query: {
		    id: e
		  }
		});
	},
	gocamp(e){
		this.$router.push({
		  path: "/CampDetails",
		  name: "CampDetails",
		  query: {
		    id: e
		  }
		});
	},
	goline(e){
		this.$router.push({
		  path: "/LineDetails",
		  name: "LineDetails",
		  query: {
		    id: e
		  }
		});
	},
	goactivity(e){
		this.$router.push({
		  path: "/Activitydetails",
		  name: "Activitydetails",
		  query: {
		    id: e
		  }
		});
	},
  }
};
	
</script>

<style scoped>
	.form_msgbox{
		flex:1;
		font-size:14px ;
	}
	.msgbox_item{
		width: 100%;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		color: #303133;
	}
	.formmsg_title{
		/* width: 110px; */
		text-align: left;
		
		font-weight: 600;
	}
	.frommsg_text{
		color: #909399;
	}
	.register_finality_icon{
		width: 200px;
		height: 200px;
		
	}
	.register_finality_icon img{
		width: 100%;
		height: 100%;
	}
	.register_finality{
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	.register_finality_title{
		font-size: 24px;
		    color: #333;
		    font-weight: 500;
		    margin-top: 30px;
	}
	.register_finality_subtitle{
		font-size: 18px;
		    color: #666;
		    margin-top: 20px;
			display: flex;
			align-items: center;
	}
		
	.register_finality_subtitle a{
		 color: #1b9d57 !important;
	}
	.register_finality_button{
		text-align: center;
		    margin-top: 50px;
	}
	.register_box{
		width: 100%;
		padding: 50px 0;
		background: #e3fce9;
	}
	.register_main{
		background-color: #fff;
		width: 850px;
		margin: auto;
		padding: 50px 30px 30px;
		border-radius: 15px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
	}
	.register_step{
/* 		    display: flex;
		   text-align: center;
		    justify-content: space-between; */
		    padding: 20px 50px 50px;
		    border-bottom: 1px solid #e9e9e9;
		    margin-bottom: 40px;
	}
	.register_main1{
		    display: flex;
		    text-align: center;
		    justify-content: space-evenly;
		    border-bottom: 1px dashed #e9e9e9;
		    padding: 0 50px 40px;
		    margin-bottom: 30px;
	}
	.register_type{
		border: 1px solid #e9e9e9;
		    padding: 20px 10px;
		    border-radius: 10px;
		    width: 200px;
		    color: #333;
		    position: relative;
		    cursor: pointer;
			border: 1px solid #9eccfd;
		    color: #9eccfd;
		    background-color: #e7f3ff;
			
	}
	.checkiconbox{
		font-size: 21px;
		position: absolute;
		right: -1px;
		top: -1px;
		background-color: #fff;
		border: 1px solid #72eb62;
		border-radius: 0 10px 0 5px;
		height: 25px;
		width: 30px;
		display: block;
		color: #259117;
		font-style: normal;
		-webkit-font-smoothing: antialiased;
	}
	.register_tipsbox{
		    padding: 10px 50px 0;
	}
	.register_tips{
		    display: flex;
		    padding: 5px 0;
			font-size: 14px;
		    color: #666;
	}
	.register_tips_title{
		width: 80px;
		    color: #333;
		    font-weight: 600;
	}
	.register_tips_text{
		flex: 1;
		text-align: center;
	}
	.slsicon{
		    border: 1px solid #72eb62;
		    color: #259117;
		    background-color: #e7fee4;
            /* width: 100px; */
            /* height: 100px; */
            /* margin:auto; */
	}
	/* .login{
		border: 1px solid #a9d3ff;
		    color: #a9d3ff;
		    background-color: #eff7ff;
			  height: 100px;
	} */
	.type_title{
		    font-size: 18px;
		    font-weight: 400;
			margin-block-start: 0.83em;
			    /* margin-block-end: 0.83em; */
			margin-inline-start: 0px;
			margin-inline-end: 0px;
	}
	.form_tips{
		width: 350px !important;
		position: relative;
		display: flex;
		padding: 9px 0!important;
		line-height: 20px;
		margin-right: 10px;
		color: #999!important;
		text-align: left;
		margin-left: 10px;
	}
	.register_buttonbox1{
		margin-top: 20px;
		position: relative;
		text-align: center;
		padding: 5px 0 10px;
		margin-bottom: 15px;
		clear: both;
		margin: 0;
		
	}
	.register_buttonbox1 button{
		    height: 44px;
		    line-height: 44px;
		    padding: 0 25px;
		    font-size: 16px;
	}
	.home_banner_text{
		width: 100%;
		    padding: 4px 0;
		    background: rgba(71,86,105,.51);
		    color: #fff;
		    text-align: center;
		    position: absolute;
		    bottom: 0;
		    height: 18px;
		    line-height: 18px;
		    font-size: 14px;
	}
	body{
		background: #ffffff;
	}
	#appbox{
		background: #ffffff;
	}
	.Home_column1{
		width: 1180px;
		display: flex;
		margin: 0 auto;
		justify-content: space-between;
		margin-top: 50px;
	}
	.Home_column2{
		width: 1180px;
		margin: 0 auto;
		margin-top: 20px;
	}
	.column_titlebox{
		width: 100%;
		padding: 20px 0px;
		display: flex;
		justify-content: space-between;
		align-items: flex-end;
	}
	.column_title{
		font-size: 22px;
		color: #1b9d57;
	}
	.column_right{
		display: flex;
		align-items: flex-end;
		
	}
	.column_right:first-child {
		 border-left: 0px !important;
	  /* 父元素的第一个子元素的样式 */
	}
	.mentor_type{
		padding: 0px 10px;
		font-size: 16px;
		border-left: 1px solid #606266;
		color:#606266 ;
	}
	.gomore_mentor{
		margin-left: 20px;
		font-size: 14px;
		color:#606266 ;
	}
	.column_gomore{
		text-align: right;
		font-size: 16px;
		color: #C0C4CC;
	}
	.column2_box{
		width: 100%;
	
		display: flex;
		justify-content: space-between;
		align-items: flex-end;
	}
	.column_blockimg{
		width: 285px;
		 box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
	}
	
	.product_box{
		width: 1180px;
		display: flex;
		align-items: center;
		justify-content: center;
		border: 1px solid #EBEEF5;
		padding: 15px 0px;
		border-radius: 5px;
		/* height: ; */
	}
	.prodduct_item{
		width: 195px;
		height: 60px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
		border-left: 1px solid #EBEEF5;
	}
		
	.prodduct_title{
		padding: 4px 10px;
		border-radius: 10px;
		margin-bottom: 4px;
		font-size: 18px;
		font-weight: 600;
		color: #303133;
	}
	.product_msg{
		font-size: 14px;
		color: #909399;
	}
	
	.mentor_item{
		padding: 20px;
		width: 330px;
		display: flex;
		align-items: center;
		background: #f9f9f9;
		border-radius: 8px;
	}
	.mentor_imgs{
		width:100px;
		height: 135px;
	}
	.mentor_imgs img{
		border-radius: 5px;
		width: 100%;
		height: 100%;
	}
		
	.mentor_msgbox{
		margin-left: 20px;
		flex: 1;
		display: flex;
		flex-direction: column;
		
	}
	.mentor_title{
		font-size: 18px;
		font-weight: 600;
		color: #303133;
		text-align: left;
	}
	.mentor_subtitle{
		font-size: 15px;
		color: #909399;
		margin: 10px 0px;
		text-align: left;
	}
	.mentor_msg{
		font-size: 12px;
		color: #909399;
		margin: 1px;
		text-align: left;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		
	}
	.Traveler_item{
		padding: 20px;
		width: 340px;
		background: #f9f9f9;
		border-radius: 8px;
	}
	.Traveler_title{
		width: 100%;
		font-size: 18px;
		color: #303133;
		text-align: left;
		margin-bottom: 10px;
	}
	.Traveler_msg{
		width: 100%;
		font-size: 14px;
		color: #909399;
		text-align: left;
	}
	.prodduct_item{
		
	}
	.column2_item{
		width: 265px;
		height: 260px;
		border-radius: 15px;
		position: relative;
	}
	.camp_rank{
		position: absolute;
		left: 0px;
		top: 0px;
		padding: 4px 8px;
		font-size: 14px;
		border-radius: 10px 0px;
		    background: #fe3113;
		    color: #ffffff;
	}
	.column2_img{
		width: 100%;
		height: 180px;
	}
	.column2_img img{
		width: 100%;
		height: 100%;
		border-radius:10px 10px 0px 0px;
	}
	.column2_title{
		padding: 10px;
		background: #f9f9f9;
		border-radius: 0px 0px 10px 10px;
		padding-bottom: 15px;
	}
	.item_title{
		font-size: 18px;
		font-weight: 600;
		color: #303133;
		margin-bottom: 15px;
		text-align: left;
		overflow: hidden;
		    white-space: nowrap;
		    text-overflow: ellipsis;
		/* text-overflow: ellipsis;
		white-space: normal;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical; */
	}
	.item_subtitle{
		font-size: 14px;
		color: #909399;
		text-align: left;
		overflow: hidden;
		    white-space: nowrap;
		    text-overflow: ellipsis;
	}
	
	
	.Home_imgs{
		width: 575px;
		
	}
	.newnews_box{
		width: 580px;
	}
	.news_top{
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: flex-end;
	}
	.news_title{
		padding: 15px;
		border-bottom: 2px solid #1b9d57;
		color: #1b9d57;
		font-size: 22px;
		font-weight: 600;
	}
	.news_gomroe{
		padding: 17px 0px;
		text-align: right;
		flex: 1;
		font-size: 16px;
		border-bottom: 1px solid #E4E7ED;
		color: #C0C4CC;
	}
	.newslist{
		width: 100%;
		display: flex;
		flex-direction: column;
		margin: 0px;
	}
	.news_item{
		text-align: left;
	}
	
	
	.plate_icon{
		width:70px;
		height: 70px;
	}
	.plate_icon img{
		width: 100%;
		width: 100%;
	}
	.plate_title{
		margin-top: 10px;
	}
	.plate_item{
		width: 340px;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		border-left: 1px solid #ffffff;
		color: #ffffff;
		font-size: 22px;
		font-weight: 600;
	}
	.plate_item:hover{
		background: #cccccc38;
	}
	.plate_item:active{
		background:#0f6a8f36;
	}
	 .plate_item:first-child {
		 border-left: 0px solid #ffffff;
	  /* 父元素的第一个子元素的样式 */
	}
	.plate_icon{
		
	}
	
	.top_minemsgbox{
		width: 1230px;
		padding:10px 0px;
		/* height: 110px; */
		display: flex;
		align-items: center;
		justify-content: flex-start;
		margin: 0 auto;
		font-size: 15px;
		color:#606266;
		/* padding: 120px; */
	}
	.welcome{
		color:#187192;
		font-size: 16px;
		margin:0px 40px;
		/* flex: 1; */
		text-align: left;
		margin-right: 200px;
		
	}
	.top_right{
		display: flex;
		align-items: center;
	}
	.top_Mobiletype{
		padding: 4px 15px;
		background: #1b9d57;
		color: #ffffff;
		border-radius: 20px;
		margin-right: 10px;
		font-size: 14px;
	}
	.top_box{
		width: 1230px !important;
		justify-content: flex-start;
	}
	.logo_box{
		margin-right: 80px;
	}
	.top_gatebox{
		margin-right: 300px;
	}
	.top_search_box{
		display: flex;
		align-items: center;
	}
	.top_search{
		display: flex;
		align-items: center;
		border: 1.5px solid #1b9d57;
		position: relative;
		padding: 6px 20px;
		border-radius: 60px;
		    margin: 0px 20px;
			font-size: 16px;
	}
	.top_search input{
		width: 300px;
		color:#747dce;
	}
	.top_search i{
		font-size: 20px;
		font-weight: 600;
		color: #C0C4CC;
	}
	.top_search_icon{
		width: 64px !important;
		height: 64px !important;
		object-fit:contain;
		position: absolute;
		right: -10px;
	}
	.toptabnav{
		height: 70px !important;
	/* 	background: #1b9d5700;
		position: absolute; */
		z-index: 99;
	}
	.top_tab_box{
		width: 100%;
		position: relative;
	}
	.top_banner{
		
	}
	.top_plate{
		/* position: absolute; */
		/* bottom: 0px; */
		width: 100%;
		height: 164px;
		display: flex;
		justify-content: center;
		background: #1b9d57;
		z-index: 99;
	}
	
	
	
	.el-tag--mini{
		font-size: 8px !important;
		    padding: 0 2.8px;
	}
	.mentor{
		width: 1100px;
		margin: 0 auto;
		margin-top: 20px;
		
	}
	.mentor_box{
		width: 1100px;
		display: flex;
		/* justify-content: ; */
		flex-wrap: wrap;
		
		background: #30313336;
	}
	.mentor_msg_box{
		position: absolute;
		width: 180px;
		height: 245px;
		background: #333333c7;
		color: #ffffff;
		top: 0px;
		    left: 0px;
	}
/* 	.mentor_title{
		padding:15px 10px;
		margin: 0px 10px;
		margin-top: 50px;
		font-size: 20px;
		font-weight: 500;
		border-bottom: 1px solid #ffffff;
	} */
	.mentor_tags{
		padding: 9px;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		justify-content: space-between;
	}
	.mentor_camp{
		font-size: 14px;
		text-align: left;
		padding: 10px;
		padding-top: 0px;
	}
	.ntmain{
		width: 1000px;
	}
	.nttext:hover{
		color: #1b9d57 !important;
	}
	.ntbox{
		width: 1060px;
		    background: #ffffff;
		    margin: 10px auto;
		    display: flex;
		    align-items: center;
		    padding: 0px 20px;
	}
	.nticon{
		width: 30px;
		height: 30px;
		margin-right: 10px;
	}
	.el-carousel__item h3{
		opacity: 1 !important;
	}
	.lessonbox{
		width: 1100px;
		margin: 0 auto;
		margin-top: 20px;
	}
	.home_titlebox{
		width: 1100px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.next_text{
		margin-bottom: 20px;
		font-size: 16px;
	}
	.camplist{
		padding: 20px;
		width:1060px ;
		background: #ffffff;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		align-items: center;
	}
	.lessonlist{
		padding: 20px;
		width:1060px ;
		background: #ffffff;
		flex-wrap: wrap;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.actlist{
		padding: 20px;
		width:1060px ;
		background: #ffffff;
		flex-wrap: wrap;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.actmsgbox{
		width: 320px;
		padding: 10px;
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
	}
	.actbutton{
		width: 80px;
		height: 30px;
		line-height: 30px;
		font-size: 18px;
		color: #ffffff;
		background: #1b9d57;
	}
	.actbutton2{
		width: 80px;
		height: 30px;
		line-height: 30px;
		font-size: 18px;
		color: #ffffff;
		background: #9e9e9e;
	}
	.actbox{
		width: 1100px;
		margin-top: 20px !important;
		margin: 0 auto;
	}
	.campitem{
		width: 340px;
		border-radius: 8px;
			color: #333;
	}
	.lessonitem{
		width: 257px;
		margin-bottom: 10px;
		color: #333;
	}
	.lessonitem:hover{
		color: #1b9d57;
	}
	.campitem:hover{
		color: #1b9d57;
	}
	.lessonimgbox{
		width: 257px;
		height: 177px;
		position: relative;
	}
	.lessonimgbox img{
		width: 100%;
		height: 100%;
	}
	.campimgbox{
		width: 340px;
		height: 168px;
		position: relative;
		
	}
	.actimgbox{
		width: 340px;
		height: 218px;
	}
	.actimgbox img{
		width: 100%;
		height: 100%;
	}
	.actpay{
		font-size: 14px;
		color: brown;
	}
	
	.campimgbox img{
		width: 100%;
		height: 100%;
		border-radius: 8px 8px 0px 0px;
	}
	.campaddress{
		width: 320px;
		position: absolute;
		bottom: 0;
		right: 0;
		z-index: 1;
		display: flex;
		justify-content: flex-end;
		align-items: flex-end;
		font-size: 12px;
		font-weight: 600;
		color: #ffffff;
		height: 26px;
		line-height: 26px;
		padding: 0 10px;
		background: #30313336;
	}
	.camptitle{
		padding: 10px;
		font-size: 18px;
		width: 320px;
		height: 46px;
	
		/* margin-bottom: 15px; */
		text-align: left;
		/* height: 50px; */
		/* line-height: 50px; */
		text-overflow: ellipsis;
		white-space: normal;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}
	.lessontitle{
		padding: 10px;
		font-size: 18px;
		width: 237px;
		height: 46px;
		text-align: left;
		text-overflow: ellipsis;
		white-space: normal;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}
	
	.imgsbox{
		/* width:1100px; */
		/* margin: 10px auto; */
	}
	.advbanner{
		width:1100px;
		margin: 0px auto;
	}
	.newsimgH{
		width: 210px;
		height: 135px;
		background-color: #333;
	}
	.newsitemH{
		width: 525px;
		padding: 10px;
		border-radius: 8px;
		display: flex;
		/* justify-content: ; */
		
		align-items: center;
		margin-bottom: 10px;
		background: #ffffff;
	}
	.newsitemH:hover{
		color: #1b9d57;
	}
	.newsitembox{
		width: 100%;
		margin-top: 10px;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		align-items: center;
	}
	.newsmsgH{
		width: 280px;
		height: 135px;
		margin-left: 20px;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: space-between;
	}
	.news_bottomH{
		width: 100%;
		display: flex;
		justify-content: space-between;
	}
	.newstitle{
		font-size: 18px;
		
	}
	.campbox{
		width: 1100px;
		margin: 0 auto;
	}
	::v-deep .el-tabs__header{
		margin: 0px !important;
	}
	::v-deep .el-tabs__item{
		font-size: 18px;
		height: 78px !important;
		line-height: 78px !important;
		/* padding:30px ; */
	}
	::v-deep .el-select>.el-input{
	width: 360px !important;
}
	::v-deep .department_select .el-select>.el-input{
	width: 200px !important;
}
.department_select{
	width: 630px;
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-start;
}
/* 	.el-tabs__content{
		background: #f5f5f5;
	} */
</style>

<style>
.el-form-item__content{
	display: flex;
	align-items: center;
}
.el-form-item__content>.el-input{
	/* width: 350px !important; */
	flex: 1;
}
.el-form-item__content>.el-input{
	/* width: 350px !important; */
	flex: 1;
}

</style>